import { useRetractableMenu } from "../context/RetractableMenuContext";
import IconButton from "./IconButton";
import { HiBars3 } from "react-icons/hi2";

function MenuIconButton({ variant }) {
    const { onClickMenuIcon } = useRetractableMenu()
    return (
        <IconButton onClick={onClickMenuIcon} variant={variant}>
            <HiBars3 />
        </IconButton>
    )
}

export default MenuIconButton